import { register } from 'register-service-worker'

import ENV from './enums/environment'
import store from './store'
import { captureExceptionWithContext } from './utils/sentry-logger'

// Ensure service worker path is always absolute from root to prevent
// registration failures on deep routes (e.g., /advisor/member/...)
const getServiceWorkerPath = () => {
  const baseUrl = process.env.VUE_APP_BASE_URL || '/'
  // Ensure path starts with / for absolute resolution
  const normalizedBase = baseUrl.startsWith('/') ? baseUrl : `/${baseUrl}`
  return `${normalizedBase}service-worker.js`
}

if (process.env.NODE_ENV === ENV.PROD) {
  let hasReportedUpdateError = false

  register(getServiceWorkerPath(), {
    ready() {
      console.log(
        'App is being served from cache by a service worker.\n' + 'For more details, visit https://goo.gl/AFskqB'
      )
    },
    registered(registration) {
      console.log('Service worker has been registered.')

      // Periodically check for updates
      setInterval(() => {
        registration.update().catch((error) => {
          // Network / fetch problems when updating the SW are expected
          // sometimes (deploy in progress, offline, etc.). Log quietly
          // instead of raising an unhandled rejection.
          console.warn('Service worker update failed:', error)
          if (!hasReportedUpdateError) {
            hasReportedUpdateError = true
            captureExceptionWithContext(error, {
              action: 'service-worker-update',
              phase: 'update',
              source: 'service-worker',
            })
          }
        })
      }, 5000)
    },
    cached() {
      console.log('Content has been cached for offline use.')
    },
    updatefound() {
      console.log('New content is downloading.')
    },
    updated() {
      console.log('New content is available; please refresh.')
      store.commit('globalComponents/setShowDialogRealodPage', true)
    },
    offline() {
      console.log('No internet connection found. App is running in offline mode.')
    },
    error(error) {
      console.error('Error during service worker registration:', error)
      captureExceptionWithContext(error, {
        action: 'service-worker-registration',
        phase: 'registration',
        source: 'service-worker',
        errorMessage: error?.message,
      })
    },
  })
}
